import Vue from 'vue'
import Store from '@/store'
import { Base64 } from '@/assets/js/base64.min.js'
import Utils from './utils'

const vue = new Vue()
const readFile = async(filePath) => {
  const data = await vue.$desktopClient.ReadTextFromFile(filePath, 'utf-8')
  return data && data.code === 'success' ? data.data : false
}
const writeFile = async(filePath, content) => {
  const data = await vue.$desktopClient.WriteTextToFile(filePath, content, 'utf-8')
  return data && data.code === 'success' ? data.data : false
}
const copyFile = (sourcePath, tagterPath) => {

}
const checkExistFile = async(path) => {
  const data = await vue.$desktopClient.ExistFile(path)
  return data && data.code === 'success' ? data.data : false
}
const checkExistFolder = (path) => {

}
const deleteFile = async(filePath) => {
  const data = await vue.$desktopClient.DeleteFile(filePath)
  return data && data.code === 'success' ? data.data : false
}
const deleteFiles = async(dirPath) => {
  const data = await vue.$desktopClient.DeleteFiles(dirPath, true, '*.*')
  return data && data.code === 'success' ? data.data : false
}
const localCachePath = () => {
  const localAppData = Store.state.localAppData
  const cachePath = process.env.VUE_APP_WINDOWS_CACHE_PATH 
  const replacements = { localAppData }  
  return replace(cachePath, replacements)  
}
const businessBasePath = (userId) => {
  const localAppData = Store.state.localAppData
  const businessBasePath = process.env.VUE_APP_WINDOWS_BUSINESS_BASE_PATH
  const replacements = { localAppData, userId } 
  return replace(businessBasePath, replacements)  
}
const businessPath = (userId, fileId) => {
  const localAppData = Store.state.localAppData
  const businessPath = process.env.VUE_APP_WINDOWS_BUSINESS_PATH
  const replacements = { localAppData, userId, fileId }  
  return replace(businessPath, replacements)  
}

const replace = (str, replacements) => {
  return str.replace(/{(\w+)}/g, (match, key) => {
    return replacements[key]
  })  
}
const writeUserToFile = async(content) => {
  const base64 = Base64.encode(`${Math.random() * 10000};${JSON.stringify(content)}`)
  return await writeFile(loginCachePath(), Utils.encrypt(base64))
}
const readUserToFile = async() => {
  const content = await readFile(loginCachePath())
  if (content) {
    const contentEncrypt = Utils.encrypt(content)
    const base64 = Base64.decode(contentEncrypt)
    return base64.split(';')[1]
  }
}
const loginCachePath = () => {
  const cachePath = localCachePath()
  const cacheFileName = `uc${process.env.NODE_ENV}${Store.state.softwareCode}`
  const loginAppDataPath = `${cachePath}\\${cacheFileName}`
  Store.commit('setLoginAppDataPath', loginAppDataPath)
  return loginAppDataPath
}

export {
  readFile,
  writeFile,
  copyFile,
  checkExistFile,
  checkExistFolder,
  deleteFile,
  deleteFiles,
  localCachePath,
  businessPath,
  businessBasePath,
  writeUserToFile,
  readUserToFile,
  loginCachePath
} 
